export { default as useUnifiedCriteriaSearch } from './useUnifiedCriteriaSearch';
export type { UnifiedSearchResult, GroupedSearchResults } from './useUnifiedCriteriaSearch';

export { useSlashCommandMenu } from './useSlashCommandMenu';
export { useComponentPortals } from './useComponentPortals';
export { useTemplateHydration } from './useTemplateHydration';
export { useGenericComponent } from './useGenericComponent';
export type {
  UseGenericComponentParams,
  UseGenericComponentReturn,
} from './useGenericComponent';

// Component registry exports
export {
  createComponentElement,
  getComponent,
  isImplemented,
  // Legacy exports (deprecated - use TYPE_REGISTRY from typeRegistry.ts)
  COMPONENT_REGISTRY,
  TYPE_CONFIG,
  getTypeConfig,
} from './componentRegistry';
export type { ComponentConfig } from './componentRegistry';
